import React, { useState, useEffect } from 'react';
import { GetData, PostData } from '../utils/api';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setLoading(true);
      const data = await GetData('/settings');
      setSettings(data.settings);
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    try {
      await PostData('/messages', formData);
      setSubmitted(true);
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      console.error('Error sending message:', err);
      setError('Error al enviar el mensaje. Por favor, intenta nuevamente.');
    } finally {
      setSending(false);
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  const contact = settings?.contact || {};

  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-header">
          <h1>Contáctanos</h1>
          <p>Estamos aquí para ayudarte. Escríbenos y te responderemos a la brevedad</p>
        </div>

        <div className="contact-content">
          {/* Información de Contacto */}
          <div className="contact-info-section">
            <h2>Información de Contacto</h2>

            <div className="contact-info-grid">
              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" fill="currentColor"/>
                  </svg>
                </div>
                <h3>Teléfono</h3>
                <p className="contact-info-value">{contact.phone || '+1 (555) 123-4567'}</p>
                <p className="contact-info-desc">{contact.workingHours?.weekdays || 'Lun - Vie: 9:00 AM - 6:00 PM'}</p>
                <a href={`tel:${contact.phone}`} className="btn btn-sm btn-light">
                  Llamar ahora
                </a>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.75 13.96C16.25 13.71 15.56 13.36 14.73 13.02C13.8 12.64 13.19 12.98 12.7 13.52C12.38 13.88 12.04 14.15 11.68 14.15C11.1 14.15 9.81 13.21 8.61 12.01C7.41 10.81 6.47 9.52 6.47 8.94C6.47 8.58 6.74 8.24 7.1 7.92C7.64 7.43 7.98 6.82 7.6 5.89C7.26 5.06 6.91 4.37 6.66 3.87C6.4 3.35 5.66 3.12 5.17 3.12C4.64 3.12 3.5 3.39 2.5 4.39C1.5 5.39 1.5 6.89 1.5 7.39C1.5 11.39 4.86 15.39 5.86 16.39L7.39 17.92C9.89 20.42 13.89 23.78 17.89 23.78C18.39 23.78 19.89 23.78 20.89 22.78C21.89 21.78 22.16 20.64 22.16 20.11C22.16 19.62 21.93 18.88 21.41 18.62C20.91 18.37 20.22 18.02 19.39 17.68C18.46 17.3 17.85 17.64 17.36 18.18C17.04 18.54 16.7 18.81 16.34 18.81C15.76 18.81 14.47 17.87 13.27 16.67C12.07 15.47 11.13 14.18 11.13 13.6C11.13 13.24 11.4 12.9 11.76 12.58C12.3 12.09 12.64 11.48 12.26 10.55C11.92 9.72 11.57 9.03 11.32 8.53C11.06 8.01 10.32 7.78 9.83 7.78C9.3 7.78 8.16 8.05 7.16 9.05" fill="currentColor"/>
                  </svg>
                </div>
                <h3>WhatsApp</h3>
                <p className="contact-info-value">{contact.whatsapp || '+1 (555) 123-4567'}</p>
                <p className="contact-info-desc">Respuesta en minutos</p>
                <a href={`https://wa.me/${contact.whatsapp?.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-light">
                  Chat en WhatsApp
                </a>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor"/>
                  </svg>
                </div>
                <h3>Email</h3>
                <p className="contact-info-value">{contact.email || 'soporte@ecommerce.com'}</p>
                <p className="contact-info-desc">Respuesta en 24 horas</p>
                <a href={`mailto:${contact.email}`} className="btn btn-sm btn-light">
                  Enviar correo
                </a>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="currentColor"/>
                  </svg>
                </div>
                <h3>Ubicación</h3>
                <p className="contact-info-value">{contact.address || 'Calle Principal 123'}</p>
                <p className="contact-info-desc">Visítanos</p>
                <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-light">
                  Ver en mapa
                </a>
              </div>
            </div>

            <div className="contact-hours">
              <h3>Horarios de Atención</h3>
              <div className="hours-grid">
                <div className="hour-row">
                  <span className="hour-day">Lunes - Viernes</span>
                  <span className="hour-time">{contact.workingHours?.weekdays || '9:00 AM - 6:00 PM'}</span>
                </div>
                <div className="hour-row">
                  <span className="hour-day">Sábados</span>
                  <span className="hour-time">{contact.workingHours?.saturday || '10:00 AM - 2:00 PM'}</span>
                </div>
                <div className="hour-row">
                  <span className="hour-day">Domingos</span>
                  <span className="hour-time">{contact.workingHours?.sunday || 'Cerrado'}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Formulario de Contacto */}
          <div className="contact-form-section">
            <h2>Envíanos un Mensaje</h2>

            {submitted && (
              <div className="contact-success">
                <p>✓ ¡Mensaje enviado con éxito! Te responderemos pronto.</p>
              </div>
            )}

            {error && (
              <div className="contact-error">
                <p>{error}</p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Nombre completo *</label>
                  <input
                    type="text"
                    name="name"
                    className="form-input"
                    placeholder="Tu nombre"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Email *</label>
                  <input
                    type="email"
                    name="email"
                    className="form-input"
                    placeholder="tu@email.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Teléfono *</label>
                <input
                  type="tel"
                  name="phone"
                  className="form-input"
                  placeholder="Tu número de teléfono"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Asunto *</label>
                <select
                  name="subject"
                  className="form-input"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                >
                  <option value="">Selecciona un asunto</option>
                  <option value="general">Consulta General</option>
                  <option value="pedido">Consulta sobre Pedido</option>
                  <option value="producto">Información de Producto</option>
                  <option value="devolucion">Devolución o Cambio</option>
                  <option value="tecnico">Soporte Técnico</option>
                  <option value="otro">Otro</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Mensaje *</label>
                <textarea
                  name="message"
                  className="form-textarea"
                  placeholder="Escribe tu mensaje aquí..."
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary btn-lg" disabled={sending}>
                {sending ? 'Enviando...' : 'Enviar Mensaje'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
